(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bundle-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bundle-picker')) {
    customElements.define(
      'bundle-picker',
      class BundlePicker extends HTMLElement {
        connectedCallback() {
          this.error = this.querySelector('[data-error]');
          this.properties = this.querySelector('[data-properties]');
          this.dialog = this.querySelector('dialog');
          this.onSubmit = this.onSubmit.bind(this);

          this.addEventListener('change', (event) => {
            if (event.target.matches('[data-bundle-radio]')) {
              this.select(event.target, true);
            } else if (event.target.matches('[data-pair-field]')) {
              event.target.classList.toggle('is-invalid', !event.target.value);
              if (event.target.matches('[data-color-field]')) this.showColor(event.target);
              this.sync();
              if (this.isComplete()) this.error.hidden = true;
            }
          });
          this.querySelectorAll('[data-size-guide-open]').forEach((button) =>
            button.addEventListener('click', () => this.dialog?.showModal())
          );
          this.dialog?.addEventListener('click', (event) => {
            if (event.target === this.dialog || event.target.closest('[data-size-guide-close]')) this.dialog.close();
          });
          document.addEventListener('submit', this.onSubmit, true);

          const init = () => {
            const checked = this.querySelector('[data-bundle-radio]:checked');
            const current = document.querySelector(`#${this.dataset.form} input[name="id"]`)?.value;
            if (checked) this.select(checked, current && checked.dataset.variantId !== current);
            if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
                if (event.data.sectionId !== this.dataset.section || !event.data.variant) return;
                const radio = this.querySelector(`[data-bundle-radio][data-variant-id="${event.data.variant.id}"]`);
                if (radio && !radio.checked) {
                  radio.checked = true;
                  this.select(radio, false);
                }
              });
            }
          };
          const ready = Promise.all(['product-info', 'product-form'].map((name) => customElements.whenDefined(name)));
          Promise.race([ready, new Promise((resolve) => setTimeout(resolve, 3000))]).then(init);
        }

        disconnectedCallback() {
          document.removeEventListener('submit', this.onSubmit, true);
          if (this.unsubscribe) this.unsubscribe();
        }

        get activeCard() {
          return this.querySelector('[data-bundle-radio]:checked')?.closest('[data-bundle-card]');
        }

        get fields() {
          return Array.from(this.activeCard?.querySelectorAll('[data-pair-field]') || []);
        }

        select(radio, updateVariant) {
          this.querySelectorAll('[data-bundle-card]').forEach((card) => {
            const active = card.contains(radio);
            card.classList.toggle('is-selected', active);
            const pairs = card.querySelector('[data-pairs]');
            if (pairs) pairs.hidden = !active;
          });
          this.error.hidden = true;
          this.sync();
          if (updateVariant) this.selectVariant(radio);
        }

        selectVariant(radio) {
          const picker = document.getElementById(`variant-selects-${this.dataset.section}`);
          const option = CSS.escape(this.dataset.option);
          const value = CSS.escape(radio.value);
          const pill = picker?.querySelector(`input[type="radio"][data-option-name="${option}"][value="${value}"]`);
          if (pill) {
            pill.checked = true;
            pill.dispatchEvent(new Event('change', { bubbles: true }));
            return;
          }
          const select = picker?.querySelector(`select[name="options[${option}]"]`);
          if (select) {
            select.value = radio.value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
            return;
          }
          document
            .querySelectorAll(`#${this.dataset.form} input[name="id"]`)
            .forEach((input) => (input.value = radio.dataset.variantId));
        }

        showColor(select) {
          const image = select.selectedOptions[0]?.dataset.image;
          if (!image) return;
          document.querySelector(`mh-gallery[data-section="${this.dataset.section}"]`)?.showImage?.(image);
        }

        isComplete() {
          return this.fields.every((field) => field.value);
        }

        sync() {
          this.properties.innerHTML = '';
          this.activeCard?.querySelectorAll('[data-pair]').forEach((row, index) => {
            const values = Array.from(row.querySelectorAll('[data-pair-field]')).map((field) => field.value);
            if (values.some((value) => !value)) return;
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = `properties[${this.dataset.pairLabel} ${index + 1}]`;
            input.value = values.join(' / ');
            input.setAttribute('form', this.dataset.form);
            this.properties.appendChild(input);
          });
        }

        onSubmit(event) {
          if (event.target.id !== this.dataset.form || this.isComplete()) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          this.error.hidden = false;
          this.fields.forEach((field) => field.classList.toggle('is-invalid', !field.value));
          this.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-drawer-extras"] && !Shopify.designMode) return;
  try {
    (() => {
    const sections = ['cart-drawer', 'cart-icon-bubble'];

    const refresh = (url, body, el) => {
      el.classList.add('is-loading');
      return fetch(url, { ...fetchConfig(), body: JSON.stringify({ ...body, sections }) })
        .then((response) => response.json())
        .then((state) => {
          if (state.status) throw new Error(state.description);
          document.querySelector('cart-drawer')?.renderContents(state);
        })
        .catch((error) => {
          console.error(error);
          el.classList.remove('is-loading');
        });
    };

    if (!customElements.get('cart-extras-add')) {
      customElements.define(
        'cart-extras-add',
        class extends HTMLElement {
          connectedCallback() {
            this.querySelector('button')?.addEventListener('click', () => {
              refresh(routes.cart_add_url, { items: [{ id: Number(this.dataset.variantId), quantity: 1 }] }, this);
            });
          }
        }
      );
    }

    if (!customElements.get('cart-extras-protection')) {
      customElements.define(
        'cart-extras-protection',
        class extends HTMLElement {
          connectedCallback() {
            this.querySelector('input')?.addEventListener('change', (event) => {
              const id = Number(this.dataset.variantId);
              if (event.target.checked) {
                refresh(routes.cart_add_url, { items: [{ id, quantity: 1 }] }, this);
              } else {
                refresh(routes.cart_change_url, { id: String(id), quantity: 0 }, this);
              }
            });
          }
        }
      );
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mh-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mh-gallery')) {
    customElements.define(
      'mh-gallery',
      class MhGallery extends HTMLElement {
        connectedCallback() {
          this.viewport = this.querySelector('[data-viewport]');
          if (!this.viewport) return;
          this.slides = Array.from(this.viewport.children);
          this.addEventListener('click', (event) => {
            const go = event.target.closest('[data-go]');
            if (go) this.goTo(Number(go.dataset.go));
            if (event.target.closest('[data-prev]')) this.goTo(this.index - 1);
            if (event.target.closest('[data-next]')) this.goTo(this.index + 1);
          });
          this.viewport.addEventListener('scroll', () => {
            window.cancelAnimationFrame(this.frame);
            this.frame = window.requestAnimationFrame(() => {
              this.setActive(Math.round(this.viewport.scrollLeft / this.viewport.clientWidth));
            });
          });
          this.viewport.addEventListener('keydown', (event) => {
            if (event.key === 'ArrowLeft') this.goTo(this.index - 1);
            if (event.key === 'ArrowRight') this.goTo(this.index + 1);
          });
          const featured = this.slides.findIndex((slide) => slide.hasAttribute('data-featured'));
          this.index = 0;
          if (featured > 0) this.goTo(featured, 'instant');
          else this.setActive(0);
        }

        goTo(index, behavior = 'smooth') {
          const count = this.slides.length;
          if (!count) return;
          this.restore();
          const target = (index + count) % count;
          this.viewport.scrollTo({ left: target * this.viewport.clientWidth, behavior });
          this.setActive(target);
        }

        goToMedia(mediaId) {
          const index = this.slides.findIndex((slide) => slide.dataset.mediaId === mediaId);
          if (index > -1) this.goTo(index);
        }

        // Jumps to the slide using this image file, or shows it in the current slide.
        showImage(src) {
          const file = (url) => new URL(url, location.href).pathname.split('/').pop();
          const name = file(src);
          const index = this.slides.findIndex((slide) => {
            const img = slide.querySelector('img');
            return img && file(img.currentSrc || img.src) === name;
          });
          if (index > -1) {
            if (index !== this.index || this.swapped) this.goTo(index);
            return;
          }
          const img = this.slides[this.index]?.querySelector('img');
          if (!img) return;
          if (!this.swapped) this.swapped = { img, src: img.src, srcset: img.srcset };
          img.removeAttribute('srcset');
          img.src = src;
        }

        restore() {
          if (!this.swapped) return;
          const { img, src, srcset } = this.swapped;
          img.src = src;
          if (srcset) img.srcset = srcset;
          this.swapped = null;
        }

        setActive(index) {
          if (index !== this.index) this.restore();
          this.index = index;
          this.querySelectorAll('[data-go]').forEach((el) => {
            const active = Number(el.dataset.go) === index;
            el.classList.toggle('is-active', active);
            if (el.classList.contains('mh-gallery__thumb')) el.setAttribute('aria-current', String(active));
          });
          const thumb = this.querySelector('.mh-gallery__thumb.is-active');
          const thumbs = thumb?.parentElement;
          if (thumb && thumbs && thumbs.scrollWidth > thumbs.clientWidth) {
            thumbs.scrollTo({ left: thumb.offsetLeft - thumbs.clientWidth / 2 + thumb.clientWidth / 2, behavior: 'smooth' });
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quantity-breaks"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('quantity-breaks')) {
    const elixirFormatMoney = (cents, format) => {
      const value = Number(cents) / 100;
      const fixed = (decimals, thousands, decimal) => {
        const [int, dec] = value.toFixed(decimals).split('.');
        return int.replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (dec ? decimal + dec : '');
      };
      return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
        switch (key) {
          case 'amount_no_decimals':
            return fixed(0, ',', '.');
          case 'amount_with_comma_separator':
            return fixed(2, '.', ',');
          case 'amount_no_decimals_with_comma_separator':
            return fixed(0, '.', ',');
          case 'amount_with_apostrophe_separator':
            return fixed(2, "'", '.');
          default:
            return fixed(2, ',', '.');
        }
      });
    };
    window.elixirFormatMoney = window.elixirFormatMoney || elixirFormatMoney;

    customElements.define(
      'quantity-breaks',
      class QuantityBreaks extends HTMLElement {
        connectedCallback() {
          this.addEventListener('change', (event) => {
            if (event.target.type === 'radio') this.apply();
          });
          const init = () => {
            this.apply();
            if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
                if (event.data.sectionId !== this.dataset.section || !event.data.variant) return;
                this.dataset.price = event.data.variant.price;
                this.updatePrices();
              });
            }
          };
          if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
          else init();
        }

        disconnectedCallback() {
          if (this.unsubscribe) this.unsubscribe();
        }

        apply() {
          const selected = this.querySelector('input[type="radio"]:checked');
          if (!selected) return;
          const inputs = document.querySelectorAll(`input[name="quantity"][form="${this.dataset.form}"]`);
          inputs.forEach((input) => {
            input.value = selected.value;
            if (!input.hasAttribute('data-qb-hidden')) input.dispatchEvent(new Event('change', { bubbles: true }));
          });
        }

        updatePrices() {
          const price = Number(this.dataset.price);
          const format = this.dataset.moneyFormat;
          this.querySelectorAll('input[type="radio"]').forEach((input) => {
            const card = input.nextElementSibling;
            const full = price * Number(input.value);
            const total = Math.floor((full * (100 - Number(input.dataset.discount))) / 100);
            const totalEl = card.querySelector('[data-total]');
            const compareEl = card.querySelector('[data-compare]');
            if (totalEl) totalEl.textContent = window.elixirFormatMoney(total, format);
            if (compareEl) compareEl.textContent = window.elixirFormatMoney(full, format);
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["review-carousel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('review-carousel')) {
    customElements.define(
      'review-carousel',
      class ReviewCarousel extends HTMLElement {
        connectedCallback() {
          this.slides = Array.from(this.children);
          this.dots = this.parentElement.querySelector('.review-carousel__dots');
          if (this.slides.length < 2) return;
          this.dots.removeAttribute('aria-hidden');
          this.slides.forEach((_, i) => {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.setAttribute('aria-label', String(i + 1));
            dot.addEventListener('click', () => this.goTo(i));
            this.dots.appendChild(dot);
          });
          this.addEventListener('scroll', () => this.update(), { passive: true });
          this.update();
          if (this.dataset.autoplay === 'true') {
            this.timer = setInterval(() => this.next(), 5000);
            this.addEventListener('pointerdown', () => clearInterval(this.timer), { once: true });
          }
        }
        disconnectedCallback() {
          clearInterval(this.timer);
        }
        get step() {
          return this.slides.length > 1 ? this.slides[1].offsetLeft - this.slides[0].offsetLeft : this.clientWidth;
        }
        index() {
          return Math.min(Math.round(this.scrollLeft / this.step), this.slides.length - 1);
        }
        goTo(i) {
          this.scrollTo({ left: i * this.step });
        }
        // Loops back to the start once the last review is in view.
        next() {
          const atEnd = this.scrollLeft + this.clientWidth >= this.scrollWidth - 2;
          this.goTo(atEnd ? 0 : this.index() + 1);
        }
        update() {
          const current = this.index();
          Array.from(this.dots.children).forEach((dot, i) => dot.setAttribute('aria-current', i === current));
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["shipping-estimate"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('shipping-estimate')) {
    customElements.define(
      'shipping-estimate',
      class ShippingEstimate extends HTMLElement {
        connectedCallback() {
          const skipWeekends = this.dataset.skipWeekends === 'true';
          const addDays = (days) => {
            const date = new Date();
            let added = 0;
            while (added < days) {
              date.setDate(date.getDate() + 1);
              if (skipWeekends && (date.getDay() === 0 || date.getDay() === 6)) continue;
              added++;
            }
            return date;
          };
          let formatter;
          try {
            formatter = new Intl.DateTimeFormat(this.dataset.locale, { weekday: 'short', month: 'short', day: 'numeric' });
          } catch (e) {
            formatter = new Intl.DateTimeFormat(undefined, { weekday: 'short', month: 'short', day: 'numeric' });
          }
          const start = this.querySelector('[data-start]');
          const end = this.querySelector('[data-end]');
          if (start) start.textContent = formatter.format(addDays(Number(this.dataset.min)));
          if (end) end.textContent = formatter.format(addDays(Number(this.dataset.max)));
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sticky-atc"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sticky-atc')) {
    customElements.define(
      'sticky-atc',
      class StickyAtc extends HTMLElement {
        connectedCallback() {
          if (this.parentElement !== document.body) {
            document.querySelectorAll(`body > sticky-atc[data-section="${this.dataset.section}"]`).forEach((el) => el.remove());
            document.body.appendChild(this);
            return;
          }
          this.button = this.querySelector('button');
          this.inner = this.querySelector('.sticky-atc__inner');
          this.options = this.querySelector('[data-options]');
          this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
          this.button.addEventListener('click', () => this.onClick());
          this.options.addEventListener('change', (event) => this.onOptionChange(event));
          this.onScroll = () => {
            window.cancelAnimationFrame(this.frame);
            this.frame = window.requestAnimationFrame(() => this.update());
          };
          window.addEventListener('scroll', this.onScroll, { passive: true });
          window.addEventListener('resize', this.onScroll, { passive: true });

          const init = () => {
            this.update();
            this.refresh();
            this.onBundleChange = (event) => {
              if (!event.target.closest(`bundle-picker[data-section="${this.dataset.section}"]`)) return;
              if (event.target.matches('[data-color-field]')) this.showColor(event.target);
              this.refresh();
            };
            document.addEventListener('change', this.onBundleChange);
            if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
                if (event.data.sectionId !== this.dataset.section) return;
                this.refresh(event.data.variant?.id);
              });
            }
          };
          if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
          else init();
        }

        get target() {
          return document.getElementById(`ProductSubmitButton-${this.dataset.section}`);
        }

        get bundle() {
          return document.querySelector(`bundle-picker[data-section="${this.dataset.section}"]`);
        }

        // The pair rows of the selected bundle card.
        get pairs() {
          return Array.from(this.bundle?.activeCard?.querySelectorAll('[data-pair]') || []);
        }

        showColor(select) {
          const thumb = select.selectedOptions[0]?.dataset.thumb;
          const img = this.querySelector('.sticky-atc__image');
          if (!thumb || !img) return;
          img.removeAttribute('srcset');
          img.src = thumb;
        }

        refresh(variantId) {
          const id = variantId || this.target?.form?.querySelector('input[name="id"]')?.value;
          const variant = this.variants[id];
          if (variant) {
            const variantEl = this.querySelector('[data-variant]');
            if (variantEl) variantEl.textContent = variant.title;
            this.querySelector('[data-price]').textContent = variant.price;
            this.button.disabled = !variant.available;
          }
          this.renderOptions();
        }

        // Mirrors the color/size fields of a single-pair bundle into the bar.
        renderOptions() {
          const pairs = this.pairs;
          const single = this.dataset.showOptions === 'true' && pairs.length === 1;
          const source = single ? Array.from(pairs[0].querySelectorAll('.bundle-picker__select')) : [];
          const key = source.map((el) => el.querySelector('select').getAttribute('aria-label')).join('|');
          if (key !== this.optionsKey) {
            this.optionsKey = key;
            this.options.replaceChildren(
              ...source.map((el, index) => {
                const clone = el.cloneNode(true);
                const select = clone.querySelector('select');
                select.removeAttribute('data-pair-field');
                select.dataset.index = index;
                select.tabIndex = this.classList.contains('is-visible') ? 0 : -1;
                return clone;
              })
            );
          }
          const fields = this.sourceFields;
          this.options.querySelectorAll('select').forEach((select, index) => {
            select.value = fields[index]?.value || '';
            if (select.value) select.classList.remove('is-invalid');
          });
          this.options.hidden = source.length === 0;
          this.inner.classList.toggle('has-options', source.length > 0);
          if (this.classList.contains('is-visible')) {
            document.body.style.setProperty('--sticky-atc-height', `${this.offsetHeight}px`);
          }
        }

        get sourceFields() {
          return Array.from(this.pairs[0]?.querySelectorAll('[data-pair-field]') || []);
        }

        onOptionChange(event) {
          const select = event.target;
          select.classList.toggle('is-invalid', !select.value);
          const field = this.sourceFields[Number(select.dataset.index)];
          if (!field) return;
          field.value = select.value;
          field.dispatchEvent(new Event('change', { bubbles: true }));
        }

        onClick() {
          const bundle = this.bundle;
          if (!bundle || bundle.isComplete()) {
            this.target?.click();
            return;
          }
          if (this.pairs.length === 1 && !this.options.hidden) {
            this.options.querySelectorAll('select').forEach((select) => {
              select.classList.toggle('is-invalid', !select.value);
            });
            this.options.querySelector('select.is-invalid')?.focus();
            return;
          }
          const card = bundle.activeCard || bundle;
          card.scrollIntoView({ behavior: 'smooth', block: 'center' });
          const empty = bundle.fields.find((field) => !field.value);
          if (empty) setTimeout(() => empty.focus({ preventScroll: true }), 500);
        }

        update() {
          const target = this.target;
          const enabled = target && getComputedStyle(this).display !== 'none';
          const visible = Boolean(enabled && target.getBoundingClientRect().bottom < 0);
          if (visible === this.classList.contains('is-visible')) return;
          this.classList.toggle('is-visible', visible);
          this.setAttribute('aria-hidden', String(!visible));
          this.querySelectorAll('button, select').forEach((el) => (el.tabIndex = visible ? 0 : -1));
          document.body.style.setProperty('--sticky-atc-height', `${this.offsetHeight}px`);
          document.body.classList.toggle('sticky-atc-open', visible);
        }

        disconnectedCallback() {
          if (!this.onScroll) return;
          window.removeEventListener('scroll', this.onScroll);
          window.removeEventListener('resize', this.onScroll);
          document.body.classList.remove('sticky-atc-open');
          if (this.onBundleChange) document.removeEventListener('change', this.onBundleChange);
          if (this.unsubscribe) this.unsubscribe();
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
